var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50898 14.025L6.87565 12.0583L4.58398 15H13.7507L10.8007 11.075L8.50898 14.025Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.7507 15H4.58398L6.87565 12.0583L8.50898 14.025L10.8007 11.075L13.7507 15ZM14.1673 5.83333H11.6673V5H3.33398V16.6667H15.0007V8.33333H14.1673V5.83333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 3.33334V0.833344H14.9993V3.33334H12.4993V5.00001H14.9993V7.49168H16.666V5.00001H19.166V3.33334H16.666ZM14.9993 16.6667H3.33268V5.00001H11.666V3.33334H3.33268C2.41602 3.33334 1.66602 4.08334 1.66602 5.00001V16.6667C1.66602 17.5833 2.41602 18.3333 3.33268 18.3333H14.9993C15.916 18.3333 16.666 17.5833 16.666 16.6667V8.33334H14.9993V16.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/upload-image.e36ecfe85246db42cc597903f5418e24.svg";
export { ForwardRef as ReactComponent };